import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { TransitionGroup } from 'react-transition-group'
import { Parallax, Background } from 'react-parallax'
import { fetchCustomPostsIfNeeded } from '../actions'
import { DEFAULT_CUSTOM_POST } from '../reducers/customposts'
import Thumb from '../components/Thumb'
import {SlideBlock, More, QuoteBox} from '../components/Blocks'
import {setHTML} from '../helpers/helpers'
import {Main, Left, Right} from '../components/Content'
import { SlideFromRight } from '../components/Transitions'
import FullScreenVideo from '../components/VideoPlayer'

class Training extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showFixedButton: false
        }
        this.toggleFixedButton = this.toggleFixedButton.bind(this)
    }
    componentWillMount() {
        const { fetchCustomPostsIfNeeded } = this.props
        fetchCustomPostsIfNeeded('trainingen')

        window.addEventListener('scroll', _.debounce(() =>{
            let supportPageOffset = window.pageXOffset !== undefined
            let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat')
            let scroll = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
            if (scroll > window.innerHeight) {
                !this.state.showFixedButton && this.toggleFixedButton(true)
            }
            else {
                this.state.showFixedButton && this.toggleFixedButton(false)
            }
        }, 300));
    }
    toggleFixedButton(bool) {
        this.setState({
            showFixedButton: bool
        })
    }
    scrollDown() {
        window.scroll({
          top: window.innerHeight, 
          left: 0, 
          behavior: 'smooth' 
        })
    }
    render() {
        const { post } = this.props
        return (
            <div className="no-padding-mobile">
                <TransitionGroup>
                {this.state.showFixedButton && 
                    <SlideFromRight>
                        <Link className="button large offerte hide-for-medium fixed-offerte" to={`#offerte`}>Meld je aan</Link>
                    </SlideFromRight>}
                </TransitionGroup>
                <Parallax strength={300}>
                    <section className="viewport-page">
                        <SlideBlock 
                            preTitle="Training"
                            text={post.cmb2._training_intro_metabox._training_intro_text} 
                            title={post.title.rendered}
                            customAction={`#offerte`}
                            center={true}
                            actionText="Meld je aan">
                            <More text="In meer detail" onClick={this.scrollDown}/>
                        </SlideBlock>
                    </section>
                    <Background className="background-image full-page">
                        <Thumb fullPage={true} backgroundImage={true} thumbid={post.featured_media} parallax={true} size="fullscreen-bg"/>
                    </Background>
                </Parallax>
                    
                <Main>
                    <Left>
                        <div>{setHTML(post.content.rendered)}</div>
                    </Left>
                    <Right>
                        {post.cmb2._training_quote_metabox._training_quote_text && 
                            <QuoteBox 
                                text={post.cmb2._training_quote_metabox._training_quote_text}
                                author={post.cmb2._training_quote_metabox._training_quote_author} />
                        }
                        <Link className="button large offerte show-for-medium" to={`#offerte`}>Meld je aan</Link>
                    </Right>
                </Main>
                {post.cmb2._training_film_metabox._training_film_id &&
                    <FullScreenVideo id={post.cmb2._training_film_metabox._training_film_id}/>
                }
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const post = state.customposts['trainingen'] || state.customposts[DEFAULT_CUSTOM_POST]
    const requestedPost = post.find(post => post.slug === ownProps.match.params.id) || post[0]
    return {
        post: requestedPost,
    }
}

export default connect(mapStateToProps,{ fetchCustomPostsIfNeeded })(Training)


// WEBPACK FOOTER //
// ./src/pages/Training.js